import React from 'react'
import {
  Container,
  Header,
  List
} from 'semantic-ui-react'
import {
  Link,
} from 'react-router-dom'

const Conversion = ({basename}) => (
  <Container text style={{ marginTop: '7em' }}>
    <Header as='h1'>How we converted the CS2013 PDF to JSON</Header>
    <p>
      To build this site,
      we first converted the <a href="https://www.acm.org/binaries/content/assets/education/cs2013_web_final.pdf">CS2013 PDF document</a> into a JSON file
      using the following semi-automatic process:
    </p>
    <List ordered divided>
      <List.Item>
        <List.Header>PDF to Text</List.Header>
        <List.Description>Convert PDF to text</List.Description>
      </List.Item>
      <List.Item>
        <List.Header>Extract Appendix A</List.Header>
        Manually delete beginning and end of document (leaving just Appendix A)
      </List.Item>
      <List.Item>
        <List.Header>Delete unprintable characters</List.Header>
        Delete any unprintable characters (e.g., line feed appearing at the beginning of lines and preventing some expected regex matches)
      </List.Item>
      <List.Item>
        <List.Header>Delete page numbers</List.Header>
        Manually delete lines that contain page numbers
      </List.Item>
      <List.Item>
        <List.Header>Delete non-structural text</List.Header>
        Manually delete introduction sections for knowledge areas or units
      </List.Item>
      <List.Item>
        <List.Header>Support parsing of high-level structure</List.Header>
        Manually add some "tags" to unambigously delineate "knowledge areas" and "knowledge units"
      </List.Item>
      <List.Item>
        <List.Header>Manually rearrange "broken" bulleted and numbered lists</List.Header>
        Using block-editing (in VS Code), fix lists (bullet symbols and bullet texts were often split into separate bunches of lines, but not always consistently)
      </List.Item>
      <List.Item>
        <List.Header>Parse text into to tree</List.Header>
        Incrementally develop a Python script (<a href={basename+"/cc13-parse.py"}>cc13-parse.py</a>) with lots of regular expressions
        to parse the text file (<a href={basename+"/cc13.txt"}>cc13.txt</a>) into a tree of Python dictionaries, and dump that to JSON
      </List.Item>
      <List.Item>
        <List.Header>Check consistency</List.Header>
        Using a Python script check (<a href={basename+"/cc13-check.py"}>cc13-check.py</a>) assertions on the produced JSON file to spot mistakes introduced by manual editing
      </List.Item>
    </List>
    <p>
      The result of this process is <a href={basename+"/cs2013.json"}>cs2013.json</a>,
      a JSON file containing all knowledge area, units, topics, and learning outcomes
      of the CS2013 curriculum.
    </p>
    <p>
      The last step also pinpointed <Link to="/conversion/mistakes/">a few minor inconsistencies</Link> in the original PDF.
    </p>
  </Container>
)

export default Conversion